const baseClasses =
  "rounded-xl border border-slate-200 bg-white shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-60";

export function formControlClass({
  className = "",
}: {
  className?: string;
} = {}): string {
  return `${baseClasses} ${className}`.replace(/\s+/g, " ").trim();
}

